import React from "react";

import { GsdInfoPanel } from "@/coquille-bridge";

import { useKarateUi } from "@/hooks/useKarateUi.js";



/**

 * @param {{ variant?: 'banner' | 'inline' | 'card' }} props

 */

export function DemoNotice({ variant = "inline" }) {

  const { ui } = useKarateUi();

  const { title, text } = ui.demoNotice;



  if (variant === "banner") {

    return (

      <GsdInfoPanel title={title} testId="demo-notice-banner" className="demo-notice demo-notice--banner">

        {text}

      </GsdInfoPanel>

    );

  }



  if (variant === "card") {

    return (

      <GsdInfoPanel title={title} testId="demo-notice-card" className="demo-notice demo-notice--card">

        {text}

      </GsdInfoPanel>

    );

  }



  return (

    <GsdInfoPanel testId="demo-notice-inline" className="demo-notice demo-notice--inline">

      {text}

    </GsdInfoPanel>

  );

}


